<template>
  <footer id="footer" class="footer bg-overlay">
    <div class="footer-top">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <div class="action-box">
              <span class="action-box-icon">
                <i class="fa fa-map-marker"></i>
              </span>
              <div class="action-box-content">
                <h3>Where We Are</h3>
                <p class="action-box-text">
                  Johnson Styles, Zambia, Zambia
                </p>
              </div>
            </div>
            <!-- Action box 1 end -->
          </div>
          <!-- Col end -->

          <div class="col-md-6">
            <div class="action-box">
              <span class="action-box-icon">
                <i class="fa fa-comments"></i>
              </span>
              <div class="action-box-content">
                <h3>Contact Us</h3>
                <p class="action-box-text">
                  Call us: +260 97 7412401
                </p>
              </div>
            </div>
            <!-- Action box 3 end -->
          </div>
          <!-- Col end -->
        </div>
        <!-- Content row end -->
      </div>
      <!--/ Container end -->
    </div>
    <!-- Footer top end -->

    <div class="footer-main">
      <div class="container">
        <div class="row">
          <div class="col-md-6 col-sm-12 footer-widget footer-about">
            <h3 class="widget-title">About Us</h3>
            <img class="footer-logo" src="@/assets/images/logo.png" alt="" />
            <p>
              To provide high quality work, customer care and maintain the
              highest level of professionalism. We do not cut corners but promot
              honesty and fairness in our relationships with our customer and
              employees. We continuously provide useful and significant
              products, services, and solutions to customers we already serve.
            </p>
            <div class="footer-social">
              <ul>
                <li>
                  <a href="#"><i class="fa fa-facebook"></i></a>
                </li>
              </ul>
            </div>
            <!-- Footer social end -->
          </div>
          <!-- Col end -->

          <div class="col-md-6 col-sm-12 footer-widget">
            <h3 class="widget-title">Working Hours</h3>
            <div class="working-hours">
              We work 7 days a week, every day excluding major holidays. Contact
              us if you have an emergency, with our Hotline and Contact form.
              <br /><br />
              Monday - Friday: <span class="text-right">10:00 - 16:00 </span>
              <br />
              Saturday: <span class="text-right">12:00 - 15:00</span> <br />
              Sunday and holidays: <span class="text-right">09:00 - 12:00</span>
            </div>
          </div>
          <!-- Col end -->
        </div>
        <!-- Row end -->
      </div>
      <!-- Container end -->
    </div>
    <!-- Footer main end -->

    <div class="copyright">
      <div class="container">
        <div class="row">
          <div class="col-xs-12 col-sm-6">
            <div class="copyright-info">
              <span
                >Copyright © {{ year }} Johnson Styles. All Rights
                Reserved.</span
              >
            </div>
          </div>
        </div>
        <!-- Row end -->

        <div
          id="back-to-top"
          data-spy="affix"
          data-offset-top="10"
          class="back-to-top affix"
        >
          <button class="btn btn-primary" title="Back to Top">
            <i class="fa fa-angle-double-up"></i>
          </button>
        </div>
      </div>
      <!-- Container end -->
    </div>
    <!-- Copyright end -->
  </footer>
  <!-- Footer end -->
</template>
<script>
export default {
  data: () => ({
    year: new Date().getFullYear()
  })
};
</script>
